import { atom } from "jotai";

import { AccountCreationStepState } from "../../../types";
import {
  VerificationModalStepStateAtom,
  VerificationModalTrackEventAtom,
} from "../../stores";

export const ProceedToAccountCreationStepAtom = atom(
  null,
  (
    get,
    set,
    {
      verifiedEmail,
      verifiedPhone,
      phoneAssignmentToken,
      emailAssignmentToken,
    }: {
      verifiedEmail: string | null;
      verifiedPhone: string | null;
      phoneAssignmentToken: string | null;
      emailAssignmentToken: string | null;
    }
  ) => {
    const track = get(VerificationModalTrackEventAtom);
    const nextStep: AccountCreationStepState = {
      step: "AccountCreation",
      verifiedEmail,
      verifiedPhone,
      phoneAssignmentToken,
      emailAssignmentToken,
      backStep: "Initial",
    };
    set(VerificationModalStepStateAtom, nextStep);
    track?.("AuthModal.AccountCreationStep", nextStep);
  }
);
